import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import * as _ from 'lodash'
import { ENV } from '../environment/environment'
import { Events } from 'ionic-angular';
import { Storage } from '@ionic/storage';

export type AuthMode = 'sso' | 'legacy';

@Injectable({
  providedIn: "root",
})
export class AuthWrapper {
    private readonly authModeKey = 'authMode';

    constructor(
        private authService: MsalService
        , private events: Events
        , private storage: Storage
    ) {
    }

    public getMode(): Promise<AuthMode | null> {
        return this.storage.get(this.authModeKey);
    }

    public async setMode(mode: AuthMode): Promise<void> {
        await this.storage.set(this.authModeKey, mode);
    }

    isAuthenticated(): boolean {
        if (_.isEmpty(this.authService.instance.getActiveAccount()) && _.isEmpty(this.storage.get('token'))) {
            return false;
        }

        // if (this.authService.instance.getAllAccounts().length === 0
        //     || _.isEmpty(this.authService.instance.getActiveAccount())
        //     || _.isEmpty(this.authService.instance.getActiveAccount().idTokenClaims)) {
        //     return false;
        // }

        return true;
    }

    isAuthorized(): boolean {
        return this.authService.instance.getActiveAccount().tenantId === ENV.msalConfig.auth.tenantId
    }

    unAuthenticatedRedirect() {
        this.events.publish('no-access');
    }

    acquireToken() {
        if (!Promise.prototype.finally) {
            Promise.prototype.finally = function (onFinally) {
                return this.then(
                    value => Promise.resolve(onFinally()).then(() => value),
                    reason => Promise.resolve(onFinally()).then(() => { throw reason })
                );
            };
        }

        return this.authService.instance.acquireTokenSilent({ scopes: ENV.apiConfig.scopes });
    }
}


// WEBPACK FOOTER //
// ./src/infra/authWrapper.ts